const React = require('react');
const TextField = require('@material-ui/core/TextField').default;


module.exports = ({
  label,
  helperText,
  black,
  ...props
}) => {
  return (
    <div className="layoutRow fhaS fvaC w">
      <div
        className="cC f14 fw5 w(|min)90 pr10 ff$2"
      >{label}</div>
      <div className="fx1 wmin0 rlv">
        {
          props.error ? (<div
            className="abs sh15 sb-15 f12 cEC4C4C fw4"
          >{helperText}</div>) : null
        }
        <TextField
          margin="none"
          variant="outlined"
          {...props}
          className={
            `w (pv17|pt14|ph20|hmin52|bxzBB|r8)>.*OutlinedInput-input
            o50>.*input.Mui-disabled
            (dn|f14|fw5|cC|ff$2)>.*OutlinedInput-root*2
            (b1.5|bcEDEEF0(>*|:h>*|>.*-focused):not[.*-error])>.*-notchedOutline*2
            ` + (props.className || '')
          }
        />
      </div>
    </div>
  );
};
